export default __webpack_public_path__ + "static/media/cox.0a06dcd3.png";